import repository from './repsitory'

const resource = '/customer'
// const token = 'token'
export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    // token (credentials) {
    //     return repository.post(`${token}`, credentials)
    // },
    // addCustomer (data) {
    //     return repository.post(`${resource}`, data)
    // },
    updateCustomer (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    // getCustomersWithOutPerson (customerId) {
    //     return repository.get(`${resource}/WithOutPerson/${customerId}`)
    // },
    // getRoles () {
    //     return repository.get(`${resource}/roles`)
    // },
}
